import Badge from "./Badge";
import Avatar from "./Avatar";
import { productType } from "types/productType";
import { useEffect, useState } from "react";

export default function ViewContents2 ({
	description
}: any) {

	let [ visible, setVisible ] = useState <string> ("hidden");
	//let [ desc, setDesc ] = useState <string> ("");

	useEffect(() => {

		
	}, [])

	return (
		<div
			dangerouslySetInnerHTML={{ __html: description}}
		/>
	);
};